module.exports = __webpack_public_path__ + "media/images/clientes_edools-f469833661c8e8e2bb09f0360fd33b0e.png";